var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"text-grey-9",on:{"click":function($event){return _vm.$emit('click')}}},[_c('u-icon',{attrs:{"name":"list-alt","type":"fa"}}),(!_vm.value)?_c('span',{staticClass:"m-l-xs text-grey-7 font-10"},[_vm._v("clique para mostrar")]):_c('span',{staticClass:"m-l-xs text-grey-7 font-10"},[_vm._v("clique para ocultar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }